import { NamedType } from "src/app/core.models/named-type";
import { getFieldsFromInstance } from "src/app/core.utilidades/graphql-utils";
import { CoeficienteIndImc } from "./coeficiente-ind-imc";
import { CoeficienteIndTasaPura } from "./coeficiente-ind-tasa-pura";
import { PreciosModalidad } from "./precios-modalidad";

export class CalculoTasaBase implements NamedType {
    // evita perder el nombre de clase cuando ivy realiza las optimizaciones de produccion
    _className: string = 'CalculoTasaBase';

    edadActuarial: number;
    capitalFallecimiento: number;
    capitalFallecimientoAccidente: number;
    capitalIncapacidad: number;
    precioAnualFallecimiento: number;
    precioAnualFallecimientoAccidente: number;
    precioAnualIncapacidad: number;
    precioMensualFallecimiento: number;
    precioMensualFallecimientoAccidente: number;
    precioMensualIncapacidad: number;
    coeficienteIndImc: CoeficienteIndImc;
    coeficienteIndTasaPura: CoeficienteIndTasaPura;
    factorDescuento: number;
    preciosAnual: PreciosModalidad;
    preciosSemestral: PreciosModalidad;
    preciosTrimestral: PreciosModalidad;
    preciosMensual: PreciosModalidad;

    constructor() {
        this.edadActuarial = 0;
        this.capitalFallecimiento = 0;
        this.capitalFallecimientoAccidente = 0;
        this.capitalIncapacidad = 0;
        this.precioAnualFallecimiento = 0;
        this.precioAnualFallecimientoAccidente = 0;
        this.precioAnualIncapacidad = 0;
        this.precioMensualFallecimiento = 0;
        this.precioMensualFallecimientoAccidente = 0;
        this.precioMensualIncapacidad = 0;
        this.coeficienteIndImc = new CoeficienteIndImc();
        this.coeficienteIndTasaPura = new CoeficienteIndTasaPura();
        // Factor de descuento (1 − Σ descuentos vigentes). 1 = sin descuento:
        // se inicializa para que getFieldsFromInstance lo incluya en la query GraphQL
        // y, si el backend no lo devuelve, degradar de forma segura a "sin descuento".
        this.factorDescuento = 1;
        // Desglose de precios de las 4 modalidades de forma de pago (Anual, Semestral,
        // Trimestral y Mensual). Se inicializan para que getFieldsFromInstance los
        // incluya en la query GraphQL y el backend devuelva el desglose completo
        // (recargo, primas netas, consorcio, CLEA, IPS, PT, recibos y prima mínima).
        this.preciosAnual = new PreciosModalidad();
        this.preciosSemestral = new PreciosModalidad();
        this.preciosTrimestral = new PreciosModalidad();
        this.preciosMensual = new PreciosModalidad();
    }

    public static getFields = () => {
        const fields: string = getFieldsFromInstance(new CalculoTasaBase());
        return fields.split('id ').join('');
    };

}
